export const SOURCE_NAME = "name";
export const SOURCE_NAME_FR = "nameFrench";
export const SOURCE_LABEL = "Name";
export const SOURCE_NAME_LABEL_FR = "Name (French)";
export const SOURCE_COMMENT = "comment";
export const SOURCE_COMMENT_LABEL = "Comment";